import { useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import { useSelector } from "react-redux";

import Game from "./Game";
import useModal from "../../hooks/useModal";
import SignInModal from "../../modals/SignInModal";
import FinishModal from "../../modals/FinishModal";

function GameWrapper() {
  const signInModalUtils = useModal(false);
  const congratsModalUtils = useModal(false);
  const { toggleShow: congratsToggleShow, setMeta: congratsSetMeta } =
    congratsModalUtils;
  const { token } = useSelector((state) => state.auth);

  const gameEndHandler = useCallback((intent, hints, guesses) => {
    // if (intent === "won") {
    axios
      .post("/games", {
        hintsUsed: 3 - hints,
        wrongGuesses: 3 - guesses,
        intent,
      })
      .then((res) => {
        congratsToggleShow();
        congratsSetMeta({ hints, guesses, intent, gameId: res.data.game._id });
      })
      .catch((err) => {
        console.log(err.response.data);
        if (!token) {
          toast.info(
            "You must be logged in to become a part of the leaderboard"
          );
        } else {
          toast.error(
            "Uh Oh! Something went wrong while saving your data on our servers"
          );
        }
      });
    // } else {
    //   congratsToggleShow();
    //   congratsSetMeta({ hints, guesses, intent });
    // }
  }, []);

  const signInOpenHandler = () => {
    signInModalUtils.toggleShow();
  };

  return (
    <GoogleOAuthProvider clientId="946246116008-flathlehq2nh08iah0ktvae1os6v4nsj.apps.googleusercontent.com">
      <ToastContainer />
      <SignInModal {...signInModalUtils} />
      <FinishModal {...congratsModalUtils} />
      <Game onSignInOpen={signInOpenHandler} onGameEnd={gameEndHandler} />
    </GoogleOAuthProvider>
  );
}

export default GameWrapper;
